/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Compact homepage review summary, sourced from the live Judge.me widget.
(function () {
  function initReviewSummary() {
    if (!document.body.classList.contains("template-index")) return;
    var main = document.querySelector("main");
    if (!main) return;
    function render() {
      if (document.getElementById("mpc-review-summary")) return true;
      var rating = main.querySelector(".jdgm-all-reviews-rating[data-score]");
      var count = main.querySelector(".jdgm-carousel-number-of-reviews[data-number-of-reviews]");
      if (!rating || !count) return false;
      var score = Number(rating.getAttribute("data-score"));
      var total = Number(count.getAttribute("data-number-of-reviews"));
      if (!(score > 0 && score <= 5 && total > 0)) return false;
      var section = rating.closest("[id^=shopify-block-]");
      if (!section) return false;
      section.style.scrollMarginTop = "220px";
      var bar = document.createElement("div");
      bar.id = "mpc-review-summary";
      bar.style.cssText = "text-align:center;padding:7px 12px;background:#f6f8fb;border-bottom:1px solid #e3e6eb;font-size:13px;line-height:20px;";
      var link = document.createElement("a");
      link.href = "#" + section.id;
      link.style.cssText = "display:inline-block;color:#343b89;text-decoration:underline;text-underline-offset:3px;";
      var star = document.createElement("span");
      star.setAttribute("aria-hidden", "true");
      star.textContent = "★ ";
      star.style.color = "#a46b00";
      link.appendChild(star);
      link.appendChild(document.createTextNode(score.toFixed(2) + "/5 from " + total.toLocaleString() + " customer reviews"));
      bar.appendChild(link);
      main.insertBefore(bar, main.firstChild);
      return true;
    }
    if (render()) return;
    var observer = new MutationObserver(function () {
      if (render()) observer.disconnect();
    });
    observer.observe(main, {childList:true, subtree:true, attributes:true, attributeFilter:["data-score", "data-number-of-reviews"]});
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReviewSummary, {once:true});
  } else {
    initReviewSummary();
  }
})();
